import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Body from '../../fields/Body';

import './style.scss';

const ParagraphBanner = props => {
    // Pull out fields.
    const { body } = props;
    // Pull fields out of relationships.
    const { image, classes } = props.r;
    const src = image.file.cis.fluid;

    const classItems = classNames('section', 'banner', {
        [`${classes[0].name}`]: classes,
    });
    return (
        <section className={classItems}>
            {image && (
                <div className="banner__image">
                    <img
                        srcSet={src.srcset}
                        sizes={src.sizes}
                        src={src.src}
                        alt=""
                    />
                </div>
            )}
            {body && (
                <div className="section__container banner__container">
                    <Body>{body.processed}</Body>
                </div>
            )}
        </section>
    );
};

ParagraphBanner.propTypes = {
    /** Unique Key for loops */
    body: PropTypes.shape({
        value: PropTypes.string,
    }),
    /** Entity References: field_icon, bg */
    r: PropTypes.shape({
        /** Background Image */
        image: PropTypes.object,
        /** Classes */
        classes: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
    }),
};

export default ParagraphBanner;
